import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Sponsors = () => {
  return (
    <React.Fragment>
      <SEO title="Sponsors | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Sponsors"
        content="The Conference"
        contentTwo="Sponsors"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div id="sponsors">
            <table width={1111}>
              <tbody>
                <tr>
                  <td width={260}>
                    <h5>&nbsp;&nbsp;Joint Sponsors</h5>
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/iasei.png"
                        alt="iasei"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://iasei.org/">
                      International Association of Swarm and Evolutionary
                      Intelligence (IASEI)
                    </a>
                  </td>
                </tr>




                {/* <tr>
                  <td width={198}>
                  <h5>&nbsp;&nbsp;Co-Sponsors</h5>
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                  </tr> */}


                {/* <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/ku.png"
                        alt="ouc"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.kanagawa-u.ac.jp/">
                      Kanagawa University{" "}
                    </a>
                  </td>
                </tr> */}

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/pku.png"
                        alt="pku"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.pku.edu.cn/">Peking University</a>
                  </td>
                </tr>


                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/sichuan.png"
                        alt="aipku"
                        // width={150}
                        height={130}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.scu.edu.cn/">
                      Sichuan University
                    </a>
                  </td>
                </tr>




                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/SUST.jpg"
                        alt="ouc"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.sustech.edu.cn/">
                      Southern University of Science and Technology{" "}
                    </a>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/tong.jpg"
                        alt="iasei"
                        width={200}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://sai.pku.edu.cn/znxyenglish/info/1372/2592.htm">
                      State Key Laboratory of General Artificial Intelligence
                    </a>
                  </td>
                </tr>






                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/cil.jpg"
                        alt="cil"
                        width={150}
                        height={130}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.cil.pku.edu.cn/">
                      Computational Intelligence Laboratory
                    </a>
                  </td>
                </tr>


                {/* <tr>
                  <td>
                    <h5>&nbsp;&nbsp;Technical Sponsor</h5>
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                </tr> */}

                <tr>
                  <td>
                    <h5>&nbsp;&nbsp;Technical Co-Sponsors</h5>
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/IEEE-Computational-Intelligence-Society.jpg"
                        alt="cis"
                        width={280}
                        height={120}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.cis.ieee.org/">
                      IEEE Computational Intelligence Society
                    </a>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/International-Neural-Network-Society.gif"
                        alt="inns"
                        width={116}
                        height={115}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.inns.org/">
                      International Neural Network Society
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/World-Federation-of-Soft-Computing.jpg"
                        alt="wsfc"
                        width={130}
                        height={118}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.softcomputing.org/">
                      World Federation of Soft Computing
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        alt="springer"
                        src="./images/logo/Springer-Verlag.jpg"
                        // width={196}
                        height={70}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.springer.com/">Springer</a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/LNCS.jpg"
                        alt="lncs"
                        width={172}
                        height={64}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.springer.com/lncs">LNCS</a>
                  </td>
                </tr>
                {/* <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/Entropy-logo3.png"
                        alt="xh"
                        // width={172}
                        height={64}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.mdpi.com/journal/entropy">
                      Entropy
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/algorithms-logo.png"
                        alt="xh"
                        // width={172}
                        height={64}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.mdpi.com/journal/algorithms">
                      Algorithms
                    </a>
                  </td>
                </tr> */}
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/xflogoL.jpg"
                        alt="xh"
                        width={145}
                        height={125}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.xinghui.com">
                      Beijing Xinghui High-Tech Co.
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/kangbo.png"
                        alt="kb"
                        width={300}
                      // height={125}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.kiha.org.cn/index.html">
                      Nanjing  Kangbo  Intelligent  Health  Academy
                    </a>
                  </td>
                </tr>
                <tr>
                  {/* <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Sponsors;
